// const site2 = document.location; const sdom2 = "crateandbarrel.com.ph"; if (site2.hostname != sdom2) window.location.assign(`https://${sdom2}${site2.pathname}`);
// static cart
// $('select.cart-item-qty').on("change", function(){ console.log("select"); });
// $('input.cart-item-qty').on("keyup input", function(){ console.log("input"); });

function getHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    return match[2];
  }
  else {
    return null;
  }
}

function getDomain(url) {
  var hostName = getHostName(url);
  var domain = hostName;

  if (hostName != null) {
    var parts = hostName.split('.').reverse();

    if (parts != null && parts.length > 1) {
      domain = parts[1] + '.' + parts[0];

      if (hostName.toLowerCase().indexOf('.com.ph') != -1 && parts.length > 2) {
        domain = parts[2] + '.' + domain;
      }
    }
  }

  return domain;
}

const sdom = "crateandbarrel.com.ph";
const site = document.location; 
const cdom = getDomain(site.href);
const domains = ["crateandbarrel.com.ph", "crateandbarrel.ph", "shopifypreview.com", "myshopify.com"];

if (domains.indexOf(cdom) < 0) {
  window.location.assign(`https://${sdom}${site.pathname}`);
}

let newsletter_qrystr = document.location.search;
if (newsletter_qrystr != "") {
  newsletter_qrystr = newsletter_qrystr.replace("?", "").split("&");
  newsletter_qrystr.map(param => {
    let customer_posted = param.split("=");    
    if (customer_posted[0] == "customer_posted" || decodeURIComponent(customer_posted[0]) == "contact[tags]") {
      setCookie("newsletter", 1, 1);
    }
  });
}

let _popup = sessionStorage.getItem("_popup");
if (! getCookie("newsletter") && _popup == 1) {
  $("#newsletter_backdrop").css({"display": "flex"});
}

if (! getCookie("newsletter") && getCookie("newsletter_minimize")) {
  $("#newsletter_backdrop").css({"display": "none"});
  $("#newsletter_mini").css({"display": "block"});
} else if (getCookie("newsletter") && ! getCookie("newsletter_minimize")) {
  $("#newsletter_backdrop").css({"display": "flex"});
  $("#newsletter_mini").css({"display": "none"});
} else if (getCookie("newsletter") && getCookie("newsletter_minimize")) {
  $("#newsletter_backdrop").css({"display": "none"});
  $("#newsletter_mini").css({"display": "none"});
}

$("#newsletter_close").on("click", function() {
  $("#newsletter_backdrop").css({"display": "none"});
  $("#newsletter_mini").css({"display": "block"});
  setCookie("newsletter_minimize", 1, 1);
});

$("#newsletter_mini_close").on("click", function() {
  setCookie("newsletter", 1, 1);
  $("#newsletter_mini").css({"display": "none"});
});

$("#newsletter_mini_text").on("click", function() {
  $("#newsletter_backdrop").css({"display": "flex"});
  $("#newsletter_mini").css({"display": "none"});
  deleteCookie("newsletter_minimize");
});

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

$(document).on("click", '#popup_newsletter button[type="submit"]', function(e){
  let email = $("#popup_newsletter_email");
  let email_error = $("#error_popup_newsletter_email");
  
  email_error.empty();
  email.removeAttr("style")
  if (validateEmail(email.val())) {
    return true;
  }
  
  email_error.html("<small>Please enter a valid email.</small>");
  email.css({ "border-color": "#f00" });
  return false;
  
}).on("click", '#footer_newsletter_submit', function(e){
  let email = $(this).closest("form").find('input[type="email"]');
  let email_error = email.siblings("#error_footer_newsletter_email");
  
  console.log(email.val());
  
  email_error.empty();
  email.removeAttr("style")
  if (validateEmail(email.val())) {
    return true;
  }
  
  email_error.html('<small style="color: red; font-size: var(--font-size-body-smallest); position: absolute; margin-top: -1px;">Please enter a valid email.</small>');
  email.css({ "border-color": "#f00" });
  return false;
});

if (window.document.location.pathname == '/challenge') {
  var w = window.innerWidth || screen.width || screen.availWidth;
  
  if (w < 768) {
    setInterval(function () {
      let $reCaptchaIframe = $('iframe[title="recaptcha challenge"]');
      if ($reCaptchaIframe) {
        let $reCaptchaOverlay = $reCaptchaIframe.parent();
        let width = (parseInt($reCaptchaOverlay.width()) / 2) * -1;
        $reCaptchaOverlay.css({
              "position":"fixed", 
              "top": "10px", 
              "left": "10px",
            });
      }
    }, 1000);
  }
  $("#newsletter_backdrop").css({"display": "none"});
}